"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FirestoreResumeWatchingManager = void 0;
var tslib_1 = require("tslib");
var firestore_1 = require("firebase/firestore");
var constants_1 = require("../../../constants/constants");
var utils_1 = require("../../../utils/utils");
var sdk_1 = require("../../../sdk/sdk");
var enums_1 = require("../../../enums");
/**
 * Implementation of the ResumeWatchingRepository interface for a FirestoreResumeWatchingManager.
 * @class
 * @implements {ResumeWatchingRepository}
 */
var FirestoreResumeWatchingManager = /** @class */ (function () {
    function FirestoreResumeWatchingManager() {
        this.firestoreService = (0, firestore_1.getFirestore)();
        this.rwConfig = sdk_1.VelvetSDK.Configuration.configuration.features.resumeWatching;
    }
    FirestoreResumeWatchingManager.prototype.add = function (userId, item, profileId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var resumeWatchingCollectionRef, error_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        resumeWatchingCollectionRef = (0, firestore_1.doc)(this.firestoreService, constants_1.COLLECTIONS.ACCOUNTS, userId, constants_1.COLLECTIONS.PROFILES, profileId, constants_1.COLLECTIONS.RESUME_WATCHING, item.slug);
                        return [4 /*yield*/, (0, firestore_1.setDoc)(resumeWatchingCollectionRef, item)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        error_1 = _a.sent();
                        throw new Error("Error adding item to user's resume: \n" + error_1);
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    FirestoreResumeWatchingManager.prototype.remove = function (userId, itemId, profileId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var resumeWatchingCollectionRef, error_2;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        resumeWatchingCollectionRef = (0, firestore_1.doc)(this.firestoreService, constants_1.COLLECTIONS.ACCOUNTS, userId, constants_1.COLLECTIONS.PROFILES, profileId, constants_1.COLLECTIONS.RESUME_WATCHING, itemId);
                        return [4 /*yield*/, (0, firestore_1.deleteDoc)(resumeWatchingCollectionRef)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        error_2 = _a.sent();
                        throw new Error("Error removing item from user's resumeWatching collection: \n" + error_2);
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    FirestoreResumeWatchingManager.prototype.getItem = function (userId, itemId, profileId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var docRef, docSnap, error_3;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        docRef = (0, firestore_1.doc)((0, firestore_1.collection)(this.firestoreService, constants_1.COLLECTIONS.ACCOUNTS, userId, constants_1.COLLECTIONS.PROFILES, profileId, constants_1.COLLECTIONS.RESUME_WATCHING), itemId);
                        return [4 /*yield*/, (0, firestore_1.getDoc)(docRef)];
                    case 1:
                        docSnap = _a.sent();
                        if (docSnap.exists()) {
                            return [2 /*return*/, docSnap.data()];
                        }
                        else {
                            return [2 /*return*/, null];
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_3 = _a.sent();
                        throw new Error("Error retrieving item from user's resumeWatching collection by id: \n" + error_3);
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    FirestoreResumeWatchingManager.prototype.getItems = function (userId, profileId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var resumeWatchingCollectionRef, resumeWatchingSnapshot, error_4;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        resumeWatchingCollectionRef = (0, firestore_1.collection)((0, firestore_1.doc)(this.firestoreService, constants_1.COLLECTIONS.ACCOUNTS, userId, constants_1.COLLECTIONS.PROFILES, profileId), constants_1.COLLECTIONS.RESUME_WATCHING);
                        return [4 /*yield*/, (0, firestore_1.getDocs)(resumeWatchingCollectionRef)];
                    case 1:
                        resumeWatchingSnapshot = _a.sent();
                        return [2 /*return*/, resumeWatchingSnapshot.docs.map(function (doc) { return doc.data(); })];
                    case 2:
                        error_4 = _a.sent();
                        throw new Error("Error retrieving all items from user's resumeWatching collection: \n" + error_4);
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    FirestoreResumeWatchingManager.prototype.getLastWatchedEpisode = function (userId, seriesId, profileId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var allEpisodes, episodesInProgress, lastWatchedEpisode, error_5;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.getItems(userId, profileId).then(function (items) {
                                return items.filter(function (episode) { return episode.parentSlug === seriesId; });
                            })];
                    case 1:
                        allEpisodes = _a.sent();
                        episodesInProgress = allEpisodes.filter(function (episode) {
                            return episode.watchedDuration <
                                ((0, utils_1.timeStringToSeconds)(episode.contextData.creditsStartTime) ||
                                    episode.resourceDuration * _this.rwConfig.maxWatchedPercentage);
                        });
                        lastWatchedEpisode = episodesInProgress.sort(function (a, b) { return b.timestamp.seconds - a.timestamp.seconds; })[0];
                        return [2 /*return*/, lastWatchedEpisode !== null && lastWatchedEpisode !== void 0 ? lastWatchedEpisode : null];
                    case 2:
                        error_5 = _a.sent();
                        throw new Error("Error getting episode from resume watching: ".concat(error_5));
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    FirestoreResumeWatchingManager.prototype.isItemInWatchingProgress = function (userId, itemId, resourceType, profileId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var item, isItemInProgress, error_6;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 5, , 6]);
                        item = void 0;
                        if (!(resourceType === enums_1.ResourceType.MOVIE)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.getItem(userId, itemId, profileId)];
                    case 1:
                        item = _a.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.getLastWatchedEpisode(userId, itemId, profileId)];
                    case 3:
                        item = _a.sent();
                        _a.label = 4;
                    case 4:
                        if (item) {
                            isItemInProgress = item &&
                                item.watchedDuration <
                                    ((0, utils_1.timeStringToSeconds)(item.contextData.creditsStartTime) ||
                                        item.resourceDuration * this.rwConfig.maxWatchedPercentage);
                            return [2 /*return*/, isItemInProgress];
                        }
                        else {
                            return [2 /*return*/, false];
                        }
                        return [3 /*break*/, 6];
                    case 5:
                        error_6 = _a.sent();
                        throw new Error("Error checking if the item is in watching progress: ".concat(error_6));
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    return FirestoreResumeWatchingManager;
}());
exports.FirestoreResumeWatchingManager = FirestoreResumeWatchingManager;
